<template>
  <div class="admin">
    <!-- Croix arménienne (khatchkar) : réutilisée via <use> -->
    <svg width="0" height="0" style="position:absolute" aria-hidden="true" focusable="false">
      <symbol id="hk-cross" viewBox="-34 -40 453 752">
<mask id="hkm" maskUnits="userSpaceOnUse" x="-20" y="-20" width="425" height="710"><rect x="-20" y="-20" width="425" height="710" fill="#fff"/><path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="#000" stroke-width="5" stroke-linejoin="round"/></mask>
<path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="currentColor" stroke-width="17" stroke-linejoin="round" mask="url(#hkm)"/>
<g transform="translate(98 40) rotate(-45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(287 40) rotate(45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 166) rotate(70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 344) rotate(110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(291 645) rotate(135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(97 645) rotate(-135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 344) rotate(-110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 166) rotate(-70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<circle cx="140" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="140" cy="44" r="5.7" fill="currentColor"/>
<circle cx="245" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="245" cy="44" r="5.7" fill="currentColor"/>
<circle cx="112" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="112" cy="88" r="5.7" fill="currentColor"/>
<circle cx="272" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="272" cy="88" r="5.7" fill="currentColor"/>
<circle cx="48" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="48" cy="208" r="5.7" fill="currentColor"/>
<circle cx="48" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="48" cy="302" r="5.7" fill="currentColor"/>
<circle cx="338" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="338" cy="208" r="5.7" fill="currentColor"/>
<circle cx="338" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="338" cy="302" r="5.7" fill="currentColor"/>
<circle cx="140" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="140" cy="602" r="5.7" fill="currentColor"/>
<circle cx="245" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="245" cy="602" r="5.7" fill="currentColor"/>
<circle cx="110" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="110" cy="592" r="5.7" fill="currentColor"/>
<circle cx="275" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="275" cy="592" r="5.7" fill="currentColor"/>
<circle cx="192" cy="245" r="74" fill="none" stroke="currentColor" stroke-width="5"/>
<line x1="252.0" y1="245.0" x2="265.0" y2="245.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="251.1" y1="255.4" x2="263.9" y2="257.7" stroke="currentColor" stroke-width="2.5"/>
<line x1="248.4" y1="265.5" x2="260.6" y2="270.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="244.0" y1="275.0" x2="255.2" y2="281.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="238.0" y1="283.6" x2="247.9" y2="291.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="230.6" y1="291.0" x2="238.9" y2="300.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="222.0" y1="297.0" x2="228.5" y2="308.2" stroke="currentColor" stroke-width="2.5"/>
<line x1="212.5" y1="301.4" x2="217.0" y2="313.6" stroke="currentColor" stroke-width="2.5"/>
<line x1="202.4" y1="304.1" x2="204.7" y2="316.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="192.0" y1="305.0" x2="192.0" y2="318.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="181.6" y1="304.1" x2="179.3" y2="316.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="171.5" y1="301.4" x2="167.0" y2="313.6" stroke="currentColor" stroke-width="2.5"/>
<line x1="162.0" y1="297.0" x2="155.5" y2="308.2" stroke="currentColor" stroke-width="2.5"/>
<line x1="153.4" y1="291.0" x2="145.1" y2="300.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="146.0" y1="283.6" x2="136.1" y2="291.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="140.0" y1="275.0" x2="128.8" y2="281.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="135.6" y1="265.5" x2="123.4" y2="270.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="132.9" y1="255.4" x2="120.1" y2="257.7" stroke="currentColor" stroke-width="2.5"/>
<line x1="132.0" y1="245.0" x2="119.0" y2="245.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="132.9" y1="234.6" x2="120.1" y2="232.3" stroke="currentColor" stroke-width="2.5"/>
<line x1="135.6" y1="224.5" x2="123.4" y2="220.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="140.0" y1="215.0" x2="128.8" y2="208.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="146.0" y1="206.4" x2="136.1" y2="198.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="153.4" y1="199.0" x2="145.1" y2="189.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="162.0" y1="193.0" x2="155.5" y2="181.8" stroke="currentColor" stroke-width="2.5"/>
<line x1="171.5" y1="188.6" x2="167.0" y2="176.4" stroke="currentColor" stroke-width="2.5"/>
<line x1="181.6" y1="185.9" x2="179.3" y2="173.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="192.0" y1="185.0" x2="192.0" y2="172.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="202.4" y1="185.9" x2="204.7" y2="173.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="212.5" y1="188.6" x2="217.0" y2="176.4" stroke="currentColor" stroke-width="2.5"/>
<line x1="222.0" y1="193.0" x2="228.5" y2="181.8" stroke="currentColor" stroke-width="2.5"/>
<line x1="230.6" y1="199.0" x2="238.9" y2="189.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="238.0" y1="206.4" x2="247.9" y2="198.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="244.0" y1="215.0" x2="255.2" y2="208.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="248.4" y1="224.5" x2="260.6" y2="220.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="251.1" y1="234.6" x2="263.9" y2="232.3" stroke="currentColor" stroke-width="2.5"/>
<circle cx="192" cy="245" r="52" fill="none" stroke="currentColor" stroke-width="6"/>
<path d="M202.0 245.0 L205.5 246.7 L208.7 249.3 L211.4 252.6 L213.4 256.7 L214.7 261.4 L215.1 266.5 L214.6 272.0 L213.0 277.6 L210.3 283.3 L206.5 288.7" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M199.1 252.1 L200.3 255.7 L200.8 259.8 L200.3 264.1 L198.9 268.4 L196.5 272.6 L193.1 276.6 L188.9 280.1 L183.7 282.9 L177.9 285.0 L171.4 286.1" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M192.0 255.0 L190.3 258.5 L187.7 261.7 L184.4 264.4 L180.3 266.4 L175.6 267.7 L170.5 268.1 L165.0 267.6 L159.4 266.0 L153.7 263.3 L148.3 259.5" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M184.9 252.1 L181.3 253.3 L177.2 253.8 L172.9 253.3 L168.6 251.9 L164.4 249.5 L160.4 246.1 L156.9 241.9 L154.1 236.7 L152.0 230.9 L150.9 224.4" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M182.0 245.0 L178.5 243.3 L175.3 240.7 L172.6 237.4 L170.6 233.3 L169.3 228.6 L168.9 223.5 L169.4 218.0 L171.0 212.4 L173.7 206.7 L177.5 201.3" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M184.9 237.9 L183.7 234.3 L183.2 230.2 L183.7 225.9 L185.1 221.6 L187.5 217.4 L190.9 213.4 L195.1 209.9 L200.3 207.1 L206.1 205.0 L212.6 203.9" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M192.0 235.0 L193.7 231.5 L196.3 228.3 L199.6 225.6 L203.7 223.6 L208.4 222.3 L213.5 221.9 L219.0 222.4 L224.6 224.0 L230.3 226.7 L235.7 230.5" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M199.1 237.9 L202.7 236.7 L206.8 236.2 L211.1 236.7 L215.4 238.1 L219.6 240.5 L223.6 243.9 L227.1 248.1 L229.9 253.3 L232.0 259.1 L233.1 265.6" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="192" cy="245" r="8" fill="currentColor"/>
<path d="M192.0 330.0 L195.0 333.0 L197.9 336.0 L200.6 339.0 L203.0 342.0 L205.1 345.0 L206.8 348.0 L208.1 351.0 L208.8 354.0 L209.0 357.0 L208.7 360.0 L207.8 363.0 L206.5 366.0 L204.7 369.0 L202.6 372.0 L200.1 375.0 L197.3 378.0 L194.4 381.0 L191.4 384.0 L188.4 387.0 L185.6 390.0 L182.9 393.0 L180.5 396.0 L178.5 399.0 L176.9 402.0 L175.8 405.0 L175.1 408.0 L175.0 411.0 L175.4 414.0 L176.4 417.0 L177.8 420.0 L179.7 423.0 L181.9 426.0 L184.5 429.0 L187.2 432.0 L190.2 435.0 L193.2 438.0 L196.1 441.0 L199.0 444.0 L201.6 447.0 L203.9 450.0 L205.8 453.0 L207.4 456.0 L208.4 459.0 L208.9 462.0 L208.9 465.0 L208.4 468.0 L207.4 471.0 L205.9 474.0 L203.9 477.0 L201.6 480.0 L199.0 483.0 L196.2 486.0 L193.2 489.0 L190.2 492.0 L187.3 495.0 L184.5 498.0 L181.9 501.0 L179.7 504.0 L177.8 507.0 L176.4 510.0 L175.5 513.0 L175.0 516.0 L175.1 519.0 L175.8 522.0 L176.9 525.0 L178.5 528.0 L180.5 531.0 L182.9 534.0 L185.5 537.0 L188.4 540.0 L191.4 543.0" fill="none" stroke="currentColor" stroke-width="7" stroke-linecap="round"/>
<path d="M192.0 330.0 L189.0 333.0 L186.1 336.0 L183.4 339.0 L181.0 342.0 L178.9 345.0 L177.2 348.0 L175.9 351.0 L175.2 354.0 L175.0 357.0 L175.3 360.0 L176.2 363.0 L177.5 366.0 L179.3 369.0 L181.4 372.0 L183.9 375.0 L186.7 378.0 L189.6 381.0 L192.6 384.0 L195.6 387.0 L198.4 390.0 L201.1 393.0 L203.5 396.0 L205.5 399.0 L207.1 402.0 L208.2 405.0 L208.9 408.0 L209.0 411.0 L208.6 414.0 L207.6 417.0 L206.2 420.0 L204.3 423.0 L202.1 426.0 L199.5 429.0 L196.8 432.0 L193.8 435.0 L190.8 438.0 L187.9 441.0 L185.0 444.0 L182.4 447.0 L180.1 450.0 L178.2 453.0 L176.6 456.0 L175.6 459.0 L175.1 462.0 L175.1 465.0 L175.6 468.0 L176.6 471.0 L178.1 474.0 L180.1 477.0 L182.4 480.0 L185.0 483.0 L187.8 486.0 L190.8 489.0 L193.8 492.0 L196.7 495.0 L199.5 498.0 L202.1 501.0 L204.3 504.0 L206.2 507.0 L207.6 510.0 L208.5 513.0 L209.0 516.0 L208.9 519.0 L208.2 522.0 L207.1 525.0 L205.5 528.0 L203.5 531.0 L201.1 534.0 L198.5 537.0 L195.6 540.0 L192.6 543.0" fill="none" stroke="currentColor" stroke-width="7" stroke-linecap="round"/>
<circle cx="192" cy="330.0" r="3.5" fill="currentColor"/>
<circle cx="192" cy="356.7" r="3.5" fill="currentColor"/>
<circle cx="192" cy="383.4" r="3.5" fill="currentColor"/>
<circle cx="192" cy="410.1" r="3.5" fill="currentColor"/>
<circle cx="192" cy="436.8" r="3.5" fill="currentColor"/>
<circle cx="192" cy="463.5" r="3.5" fill="currentColor"/>
<circle cx="192" cy="490.2" r="3.5" fill="currentColor"/>
<g transform="translate(192 170) rotate(0)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="4" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<g transform="translate(192 555) rotate(180)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="4" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<path d="M192 560 L165 590 L192 600 L219 590Z" fill="none" stroke="currentColor" stroke-width="4" stroke-linejoin="round"/>
      </symbol>
      <symbol id="hk-cross-sm" viewBox="-44 -40 473 752">
<mask id="hkm-sm" maskUnits="userSpaceOnUse" x="-20" y="-20" width="425" height="710"><rect x="-20" y="-20" width="425" height="710" fill="#fff"/><path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="#000" stroke-width="6" stroke-linejoin="round"/></mask>
<path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="currentColor" stroke-width="19" stroke-linejoin="round" mask="url(#hkm-sm)"/>
<g transform="translate(98 40) rotate(-45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(287 40) rotate(45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 166) rotate(70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 344) rotate(110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(291 645) rotate(135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(97 645) rotate(-135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 344) rotate(-110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 166) rotate(-70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<circle cx="140" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="140" cy="44" r="7" fill="currentColor"/>
<circle cx="245" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="245" cy="44" r="7" fill="currentColor"/>
<circle cx="112" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="112" cy="88" r="7" fill="currentColor"/>
<circle cx="272" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="272" cy="88" r="7" fill="currentColor"/>
<circle cx="48" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="48" cy="208" r="7" fill="currentColor"/>
<circle cx="48" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="48" cy="302" r="7" fill="currentColor"/>
<circle cx="338" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="338" cy="208" r="7" fill="currentColor"/>
<circle cx="338" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="338" cy="302" r="7" fill="currentColor"/>
<circle cx="140" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="140" cy="602" r="7" fill="currentColor"/>
<circle cx="245" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="245" cy="602" r="7" fill="currentColor"/>
<circle cx="110" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="110" cy="592" r="7" fill="currentColor"/>
<circle cx="275" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="275" cy="592" r="7" fill="currentColor"/>
<circle cx="192" cy="245" r="76" fill="none" stroke="currentColor" stroke-width="8"/>
<line x1="254.0" y1="245.0" x2="266.0" y2="245.0" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="250.3" y1="266.2" x2="261.5" y2="270.3" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="239.5" y1="284.9" x2="248.7" y2="292.6" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="223.0" y1="298.7" x2="229.0" y2="309.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="202.8" y1="306.1" x2="204.8" y2="317.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="181.2" y1="306.1" x2="179.2" y2="317.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="161.0" y1="298.7" x2="155.0" y2="309.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="144.5" y1="284.9" x2="135.3" y2="292.6" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="133.7" y1="266.2" x2="122.5" y2="270.3" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="130.0" y1="245.0" x2="118.0" y2="245.0" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="133.7" y1="223.8" x2="122.5" y2="219.7" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="144.5" y1="205.1" x2="135.3" y2="197.4" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="161.0" y1="191.3" x2="155.0" y2="180.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="181.2" y1="183.9" x2="179.2" y2="172.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="202.8" y1="183.9" x2="204.8" y2="172.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="223.0" y1="191.3" x2="229.0" y2="180.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="239.5" y1="205.1" x2="248.7" y2="197.4" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="250.3" y1="223.8" x2="261.5" y2="219.7" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<circle cx="192" cy="245" r="54" fill="none" stroke="currentColor" stroke-width="9"/>
<path d="M207.0 245.0 L209.9 247.4 L212.4 250.7 L214.3 254.6 L215.5 259.1 L215.8 264.1 L215.2 269.3 L213.5 274.7 L210.8 280.1 L206.9 285.2 L202.1 289.9" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M201.4 256.7 L201.3 260.5 L200.3 264.5 L198.4 268.4 L195.6 272.2 L191.9 275.5 L187.4 278.3 L182.1 280.4 L176.3 281.6 L169.9 281.8 L163.2 280.9" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M188.7 259.6 L185.6 261.9 L181.9 263.7 L177.7 264.6 L173.0 264.8 L168.1 264.0 L163.1 262.2 L158.2 259.3 L153.6 255.5 L149.5 250.6 L146.0 244.8" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M178.5 251.5 L174.8 250.6 L171.1 248.8 L167.7 246.1 L164.7 242.5 L162.3 238.2 L160.6 233.1 L159.7 227.5 L159.9 221.5 L161.1 215.3 L163.4 208.9" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M178.5 238.5 L176.9 235.0 L176.0 231.0 L176.0 226.7 L176.9 222.1 L178.8 217.5 L181.7 213.0 L185.5 208.9 L190.3 205.2 L196.0 202.3 L202.4 200.2" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M188.7 230.4 L190.4 227.0 L193.0 223.8 L196.4 221.1 L200.5 219.0 L205.3 217.5 L210.6 217.0 L216.2 217.4 L222.0 218.9 L227.9 221.5 L233.5 225.2" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M201.4 233.3 L205.1 232.5 L209.2 232.6 L213.4 233.5 L217.7 235.4 L221.7 238.3 L225.5 242.1 L228.7 246.7 L231.1 252.2 L232.8 258.4 L233.4 265.1" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="192" cy="245" r="9" fill="currentColor"/>
<path d="M192.0 330.0 L195.0 333.0 L197.9 336.0 L200.6 339.0 L203.0 342.0 L205.1 345.0 L206.8 348.0 L208.1 351.0 L208.8 354.0 L209.0 357.0 L208.7 360.0 L207.8 363.0 L206.5 366.0 L204.7 369.0 L202.6 372.0 L200.1 375.0 L197.3 378.0 L194.4 381.0 L191.4 384.0 L188.4 387.0 L185.6 390.0 L182.9 393.0 L180.5 396.0 L178.5 399.0 L176.9 402.0 L175.8 405.0 L175.1 408.0 L175.0 411.0 L175.4 414.0 L176.4 417.0 L177.8 420.0 L179.7 423.0 L181.9 426.0 L184.5 429.0 L187.2 432.0 L190.2 435.0 L193.2 438.0 L196.1 441.0 L199.0 444.0 L201.6 447.0 L203.9 450.0 L205.8 453.0 L207.4 456.0 L208.4 459.0 L208.9 462.0 L208.9 465.0 L208.4 468.0 L207.4 471.0 L205.9 474.0 L203.9 477.0 L201.6 480.0 L199.0 483.0 L196.2 486.0 L193.2 489.0 L190.2 492.0 L187.3 495.0 L184.5 498.0 L181.9 501.0 L179.7 504.0 L177.8 507.0 L176.4 510.0 L175.5 513.0 L175.0 516.0 L175.1 519.0 L175.8 522.0 L176.9 525.0 L178.5 528.0 L180.5 531.0 L182.9 534.0 L185.5 537.0 L188.4 540.0 L191.4 543.0" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round"/>
<path d="M192.0 330.0 L189.0 333.0 L186.1 336.0 L183.4 339.0 L181.0 342.0 L178.9 345.0 L177.2 348.0 L175.9 351.0 L175.2 354.0 L175.0 357.0 L175.3 360.0 L176.2 363.0 L177.5 366.0 L179.3 369.0 L181.4 372.0 L183.9 375.0 L186.7 378.0 L189.6 381.0 L192.6 384.0 L195.6 387.0 L198.4 390.0 L201.1 393.0 L203.5 396.0 L205.5 399.0 L207.1 402.0 L208.2 405.0 L208.9 408.0 L209.0 411.0 L208.6 414.0 L207.6 417.0 L206.2 420.0 L204.3 423.0 L202.1 426.0 L199.5 429.0 L196.8 432.0 L193.8 435.0 L190.8 438.0 L187.9 441.0 L185.0 444.0 L182.4 447.0 L180.1 450.0 L178.2 453.0 L176.6 456.0 L175.6 459.0 L175.1 462.0 L175.1 465.0 L175.6 468.0 L176.6 471.0 L178.1 474.0 L180.1 477.0 L182.4 480.0 L185.0 483.0 L187.8 486.0 L190.8 489.0 L193.8 492.0 L196.7 495.0 L199.5 498.0 L202.1 501.0 L204.3 504.0 L206.2 507.0 L207.6 510.0 L208.5 513.0 L209.0 516.0 L208.9 519.0 L208.2 522.0 L207.1 525.0 L205.5 528.0 L203.5 531.0 L201.1 534.0 L198.5 537.0 L195.6 540.0 L192.6 543.0" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round"/>
<circle cx="192" cy="330.0" r="5" fill="currentColor"/>
<circle cx="192" cy="356.7" r="5" fill="currentColor"/>
<circle cx="192" cy="383.4" r="5" fill="currentColor"/>
<circle cx="192" cy="410.1" r="5" fill="currentColor"/>
<circle cx="192" cy="436.8" r="5" fill="currentColor"/>
<circle cx="192" cy="463.5" r="5" fill="currentColor"/>
<circle cx="192" cy="490.2" r="5" fill="currentColor"/>
<g transform="translate(192 170) rotate(0)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="6" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<g transform="translate(192 555) rotate(180)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="6" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<path d="M192 560 L165 590 L192 600 L219 590Z" fill="none" stroke="currentColor" stroke-width="6" stroke-linejoin="round"/>
      </symbol>
    </svg>

    <div class="lattice" aria-hidden="true"></div>
    <svg class="bg-cross" aria-hidden="true"><use href="#hk-cross" /></svg>

    <div class="shell">
      <header class="top-header">
        <div class="brand">
          <div class="brand-mark"><img :src="Logo" alt="HayMiutyun" /></div>
          <div>
            <span class="eyebrow">
              <svg class="eyebrow-cross" aria-hidden="true"><use href="#hk-cross-sm" /></svg>
              Espace administrateur
            </span>
            <h1>Événements</h1>
            <p>Validation et gestion des événements arméniens</p>
          </div>
        </div>

        <nav class="header-actions">
          <button class="nav-btn" @click="$router.push('/dashboard')">
            <svg viewBox="0 0 24 24"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>
            Dashboard
          </button>
          <button class="nav-btn primary" @click="loadEvents">
            <svg viewBox="0 0 24 24" :class="{ spin: loading }"><path d="M20 5v5h-5M4 19v-5h5M19 10A7.5 7.5 0 0 0 6 7M5 14a7.5 7.5 0 0 0 13 3"/></svg>
            Actualiser
          </button>
        </nav>
      </header>

      <div class="tricolor"></div>

      <section class="stats">
        <article class="stat-card">
          <div class="stat-icon">
            <svg viewBox="0 0 24 24"><path d="M5 5h14v15H5zM5 10h14M9 3v4M15 3v4"/></svg>
          </div>
          <div><h2>{{ events.length }}</h2><p>Total des événements</p></div>
        </article>

        <article class="stat-card waiting-box">
          <div class="stat-icon">
            <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
          </div>
          <div><h2>{{ pendingCount }}</h2><p>En attente de validation</p></div>
        </article>

        <article class="stat-card done-box">
          <div class="stat-icon">
            <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="m8 12.5 3 3 5-6"/></svg>
          </div>
          <div><h2>{{ events.length - pendingCount }}</h2><p>Publiés</p></div>
        </article>
      </section>

      <section class="toolbar">
        <div class="seg">
          <button :class="{ active: filter === 'all' }" @click="filter = 'all'">Tous</button>
          <button :class="{ active: filter === 'pending' }" @click="filter = 'pending'">
            En attente
            <span v-if="pendingCount" class="pill">{{ pendingCount }}</span>
          </button>
          <button :class="{ active: filter === 'published' }" @click="filter = 'published'">Publiés</button>
        </div>
        <p class="count"><strong>{{ filteredEvents.length }}</strong> événement{{ filteredEvents.length > 1 ? 's' : '' }}</p>
      </section>

      <div v-if="loading" class="empty">
        <span class="loader"></span>
        Chargement…
      </div>

      <div v-else-if="filteredEvents.length === 0" class="empty">
        <svg class="empty-cross" aria-hidden="true"><use href="#hk-cross-sm" /></svg>
        Aucun événement dans cette catégorie.
      </div>

      <article
        v-for="event in filteredEvents"
        :key="event.id"
        class="card event-card"
        :class="{ published: event.published }"
      >
        <div v-if="event.image" class="event-image">
          <img :src="getImageUrl(event)" :alt="event.title" />
        </div>

        <div class="event-content">
          <span class="status" :class="event.published ? 'done' : 'waiting'">
            {{ event.published ? 'Publié' : 'En attente de validation' }}
          </span>

          <h3>{{ event.title }}</h3>

          <ul class="meta">
            <li>
              <svg viewBox="0 0 24 24"><path d="M5 5h14v15H5zM5 10h14M9 3v4M15 3v4"/></svg>
              <span class="cap">{{ formatDate(event.date) }}</span>
              <template v-if="event.time"> · {{ event.time }}</template>
            </li>
            <li>
              <svg viewBox="0 0 24 24"><path d="M12 21s7-6.200 7-12a7 7 0 0 0-14 0c0 5.800 7 12 7 12z"/><circle cx="12" cy="9" r="2.500"/></svg>
              {{ event.location || event.city }}
              <template v-if="event.address"> — {{ event.address }}</template>
            </li>
          </ul>

          <p class="event-description">{{ event.description }}</p>

          <div class="actions">
            <button class="edit" @click="editEvent(event)">Modifier</button>

            <button v-if="!event.published" class="publish" @click="publishEvent(event.id)">
              Valider et publier
            </button>
            <button v-else class="unpublish" @click="unpublishEvent(event.id)">
              Retirer de la publication
            </button>

            <button class="delete" @click="deleteEvent(event.id)">Supprimer</button>
          </div>
        </div>
      </article>
    </div>

    <!-- MODIFICATION -->
    <div v-if="editing" class="modal" @click.self="cancelEdit">
      <div class="modal-box wide">
        <div class="modal-head">
          <div>
            <span class="eyebrow">Édition</span>
            <h2>Modifier l'événement</h2>
            <p>Modifie les informations avant validation.</p>
          </div>
          <button class="close-btn" type="button" @click="cancelEdit" aria-label="Fermer">×</button>
        </div>

        <form @submit.prevent="saveEvent">
          <div class="form-grid">
            <div class="form-group full">
              <label>Nom de l'événement *</label>
              <input v-model="form.title" type="text" required />
            </div>

            <div class="form-group">
              <label>Date *</label>
              <input v-model="form.date" type="date" required />
            </div>

            <div class="form-group">
              <label>Heure *</label>
              <input v-model="form.time" type="time" required />
            </div>

            <div class="form-group">
              <label>Ville *</label>
              <input v-model="form.city" type="text" required />
            </div>

            <div class="form-group">
              <label>Lieu</label>
              <input v-model="form.location" type="text" />
            </div>

            <div class="form-group full">
              <label>Adresse</label>
              <input v-model="form.address" type="text" />
            </div>

            <div class="form-group full">
              <label>Description *</label>
              <textarea v-model="form.description" rows="5" required></textarea>
            </div>

            <div class="form-group full">
              <label>Image</label>
              <input type="file" accept="image/*" @change="handleImage" />
            </div>

            <div v-if="previewImage" class="image-preview">
              <img :src="previewImage" />
            </div>

            <div class="form-group full">
              <label>Lien de l'événement</label>
              <input v-model="form.url" type="url" placeholder="https://..." />
            </div>
          </div>

          <div class="modal-actions">
            <button type="button" class="cancel" @click="cancelEdit">Annuler</button>
            <button type="submit" class="save" :disabled="saving">
              {{ saving ? "Enregistrement..." : "Enregistrer les modifications" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>

import { computed, onMounted, ref } from "vue"
import API_URL from "@/config/api"
import Logo from "@/assets/HayMiutyunRemove.png"

const events = ref([])
const loading = ref(true)
const saving = ref(false)

const filter = ref("all")

const editing = ref(false)
const editingId = ref(null)

const previewImage = ref(null)
const selectedImage = ref(null)


const form = ref({
  title: "",
  description: "",
  date: "",
  time: "",
  city: "",
  location: "",
  address: "",
  url: ""
})


const filteredEvents = computed(() => {

  if (filter.value === "pending") {
    return events.value.filter(event => !event.published)
  }

  if (filter.value === "published") {
    return events.value.filter(event => event.published)
  }

  return events.value

})


const pendingCount = computed(() => {
  return events.value.filter(event => !event.published).length
})


const loadEvents = async () => {

  loading.value = true

  try {

    const response = await fetch(`${API_URL}/api/events`)

    if (!response.ok) {
      throw new Error("Erreur lors du chargement")
    }

    events.value = await response.json()

  } catch (error) {

    console.error(error)

  } finally {

    loading.value = false

  }

}


const editEvent = (event) => {

  editing.value = true
  editingId.value = event.id

  form.value = {
    title: event.title || "",
    description: event.description || "",
    date: event.date
      ? event.date.substring(0, 10)
      : "",
    time: event.time
      ? event.time.substring(0, 5)
      : "",
    city: event.city || "",
    location: event.location || "",
    address: event.address || "",
    url: event.url || ""
  }

  previewImage.value = event.image || null
  selectedImage.value = null

}


const cancelEdit = () => {

  editing.value = false
  editingId.value = null
  previewImage.value = null
  selectedImage.value = null

}


const handleImage = (event) => {

  const file = event.target.files[0]

  if (!file) return

  selectedImage.value = file
  previewImage.value = URL.createObjectURL(file)

}


const saveEvent = async () => {

  if (!editingId.value) return

  saving.value = true

  try {

    const formData = new FormData()

    formData.append("Title", form.value.title)
    formData.append("Description", form.value.description)
    formData.append("Date", form.value.date)
    formData.append("Time", form.value.time)
    formData.append("City", form.value.city)
    formData.append("Location", form.value.location)
    formData.append("Address", form.value.address)
    formData.append("Url", form.value.url)

    // On conserve le statut actuel
    const currentEvent = events.value.find(
      event => event.id === editingId.value
    )

    formData.append(
      "Published",
      currentEvent?.published ? "true" : "false"
    )

    if (selectedImage.value) {
      formData.append("Image", selectedImage.value)
    }

    const response = await fetch(
      `${API_URL}/api/events/${editingId.value}`,
      {
        method: "PUT",
        body: formData
      }
    )

    if (!response.ok) {
      throw new Error("Erreur lors de la modification")
    }

    await loadEvents()

    cancelEdit()

  } catch (error) {

    console.error(error)
    alert("Impossible de modifier l'événement.")

  } finally {

    saving.value = false

  }

}


const publishEvent = async (id) => {

  if (!confirm(
    "Valider cet événement et le rendre visible sur le site ?"
  )) {
    return
  }

  try {

    const response = await fetch(
      `${API_URL}/api/events/${id}/publish`,
      {
        method: "PUT"
      }
    )

    if (!response.ok) {
      throw new Error("Erreur")
    }

    await loadEvents()

  } catch (error) {

    console.error(error)
    alert("Impossible de publier l'événement.")

  }

}


const unpublishEvent = async (id) => {

  if (!confirm(
    "Retirer cet événement de la publication ?"
  )) {
    return
  }

  try {

    const response = await fetch(
      `${API_URL}/api/events/${id}/unpublish`,
      {
        method: "PUT"
      }
    )

    if (!response.ok) {
      throw new Error("Erreur")
    }

    await loadEvents()

  } catch (error) {

    console.error(error)
    alert("Impossible de retirer l'événement.")

  }

}


const deleteEvent = async (id) => {

  if (!confirm(
    "Supprimer définitivement cet événement ?"
  )) {
    return
  }

  try {

    const response = await fetch(
      `${API_URL}/api/events/${id}`,
      {
        method: "DELETE"
      }
    )

    if (!response.ok) {
      throw new Error("Erreur")
    }

    await loadEvents()

  } catch (error) {

    console.error(error)
    alert("Impossible de supprimer l'événement.")

  }

}


const getImageUrl = (event) => {
  return event.image || null
}


const formatDate = (date) => {

  if (!date) return ""

  return new Date(date).toLocaleDateString(
    "fr-FR",
    {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric"
    }
  )

}


onMounted(() => {
  loadEvents()
})

</script>

<style scoped>
* { box-sizing: border-box; }

.admin {
  --red: #d90012;
  --red-deep: #8f0010;
  --blue: #0033a0;
  --orange: #f2a800;
  --green: #1f7a3a;
  --ink: #1c1511;
  --muted: #7a6e63;
  --line: #e8dfd0;
  --paper: #faf6ef;
  --paper-2: #f3ecdf;
  --card: #ffffff;
  --tricolor: linear-gradient(90deg, var(--red) 0 42%, var(--blue) 42% 72%, var(--orange) 72%);

  position: relative;
  min-height: 100vh;
  background: var(--paper);
  color: var(--ink);
  font-family: "Instrument Sans", Inter, system-ui, sans-serif;
  overflow: hidden;
}

.shell {
  position: relative;
  z-index: 1;
  max-width: 1280px;
  margin: 0 auto;
  padding: 40px 32px 80px;
}

/* Fond : croix arméniennes (khachkars) */
.lattice {
  position: absolute;
  inset: 0 0 auto 0;
  height: 700px;
  pointer-events: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='104' height='163' viewBox='-60 -50 505 792' fill='none' opacity='.24'%3E%3Cmask id='m' maskUnits='userSpaceOnUse' x='-20' y='-20' width='425' height='710'%3E%3Crect x='-20' y='-20' width='425' height='710' fill='%23fff'/%3E%3Cpath d='M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z' fill='none' stroke='%23000' stroke-width='6' stroke-linejoin='round'/%3E%3C/mask%3E%3Cpath d='M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z' fill='none' stroke='%23d90012' stroke-width='19' stroke-linejoin='round' mask='url(%23m)'/%3E%3Cg transform='translate(98 40) rotate(-45)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(287 40) rotate(45)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(356 166) rotate(70)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(356 344) rotate(110)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(291 645) rotate(135)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(97 645) rotate(-135)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(29 344) rotate(-110)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(29 166) rotate(-70)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Ccircle cx='140' cy='44' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='140' cy='44' r='7' fill='%23d90012'/%3E%3Ccircle cx='245' cy='44' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='245' cy='44' r='7' fill='%23d90012'/%3E%3Ccircle cx='112' cy='88' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='112' cy='88' r='7' fill='%23d90012'/%3E%3Ccircle cx='272' cy='88' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='272' cy='88' r='7' fill='%23d90012'/%3E%3Ccircle cx='48' cy='208' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='48' cy='208' r='7' fill='%23d90012'/%3E%3Ccircle cx='48' cy='302' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='48' cy='302' r='7' fill='%23d90012'/%3E%3Ccircle cx='338' cy='208' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='338' cy='208' r='7' fill='%23d90012'/%3E%3Ccircle cx='338' cy='302' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='338' cy='302' r='7' fill='%23d90012'/%3E%3Ccircle cx='140' cy='602' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='140' cy='602' r='7' fill='%23d90012'/%3E%3Ccircle cx='245' cy='602' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='245' cy='602' r='7' fill='%23d90012'/%3E%3Ccircle cx='110' cy='592' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='110' cy='592' r='7' fill='%23d90012'/%3E%3Ccircle cx='275' cy='592' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='275' cy='592' r='7' fill='%23d90012'/%3E%3Ccircle cx='192' cy='245' r='76' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Cline x1='254.0' y1='245.0' x2='266.0' y2='245.0' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='250.3' y1='266.2' x2='261.5' y2='270.3' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='239.5' y1='284.9' x2='248.7' y2='292.6' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='223.0' y1='298.7' x2='229.0' y2='309.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='202.8' y1='306.1' x2='204.8' y2='317.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='181.2' y1='306.1' x2='179.2' y2='317.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='161.0' y1='298.7' x2='155.0' y2='309.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='144.5' y1='284.9' x2='135.3' y2='292.6' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='133.7' y1='266.2' x2='122.5' y2='270.3' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='130.0' y1='245.0' x2='118.0' y2='245.0' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='133.7' y1='223.8' x2='122.5' y2='219.7' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='144.5' y1='205.1' x2='135.3' y2='197.4' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='161.0' y1='191.3' x2='155.0' y2='180.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='181.2' y1='183.9' x2='179.2' y2='172.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='202.8' y1='183.9' x2='204.8' y2='172.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='223.0' y1='191.3' x2='229.0' y2='180.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='239.5' y1='205.1' x2='248.7' y2='197.4' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='250.3' y1='223.8' x2='261.5' y2='219.7' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Ccircle cx='192' cy='245' r='54' fill='none' stroke='%23d90012' stroke-width='9'/%3E%3Cpath d='M207.0 245.0 L209.9 247.4 L212.4 250.7 L214.3 254.6 L215.5 259.1 L215.8 264.1 L215.2 269.3 L213.5 274.7 L210.8 280.1 L206.9 285.2 L202.1 289.9' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M201.4 256.7 L201.3 260.5 L200.3 264.5 L198.4 268.4 L195.6 272.2 L191.9 275.5 L187.4 278.3 L182.1 280.4 L176.3 281.6 L169.9 281.8 L163.2 280.9' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M188.7 259.6 L185.6 261.9 L181.9 263.7 L177.7 264.6 L173.0 264.8 L168.1 264.0 L163.1 262.2 L158.2 259.3 L153.6 255.5 L149.5 250.6 L146.0 244.8' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M178.5 251.5 L174.8 250.6 L171.1 248.8 L167.7 246.1 L164.7 242.5 L162.3 238.2 L160.6 233.1 L159.7 227.5 L159.9 221.5 L161.1 215.3 L163.4 208.9' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M178.5 238.5 L176.9 235.0 L176.0 231.0 L176.0 226.7 L176.9 222.1 L178.8 217.5 L181.7 213.0 L185.5 208.9 L190.3 205.2 L196.0 202.3 L202.4 200.2' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M188.7 230.4 L190.4 227.0 L193.0 223.8 L196.4 221.1 L200.5 219.0 L205.3 217.5 L210.6 217.0 L216.2 217.4 L222.0 218.9 L227.9 221.5 L233.5 225.2' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M201.4 233.3 L205.1 232.5 L209.2 232.6 L213.4 233.5 L217.7 235.4 L221.7 238.3 L225.5 242.1 L228.7 246.7 L231.1 252.2 L232.8 258.4 L233.4 265.1' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Ccircle cx='192' cy='245' r='9' fill='%23d90012'/%3E%3Cpath d='M192.0 330.0 L195.0 333.0 L197.9 336.0 L200.6 339.0 L203.0 342.0 L205.1 345.0 L206.8 348.0 L208.1 351.0 L208.8 354.0 L209.0 357.0 L208.7 360.0 L207.8 363.0 L206.5 366.0 L204.7 369.0 L202.6 372.0 L200.1 375.0 L197.3 378.0 L194.4 381.0 L191.4 384.0 L188.4 387.0 L185.6 390.0 L182.9 393.0 L180.5 396.0 L178.5 399.0 L176.9 402.0 L175.8 405.0 L175.1 408.0 L175.0 411.0 L175.4 414.0 L176.4 417.0 L177.8 420.0 L179.7 423.0 L181.9 426.0 L184.5 429.0 L187.2 432.0 L190.2 435.0 L193.2 438.0 L196.1 441.0 L199.0 444.0 L201.6 447.0 L203.9 450.0 L205.8 453.0 L207.4 456.0 L208.4 459.0 L208.9 462.0 L208.9 465.0 L208.4 468.0 L207.4 471.0 L205.9 474.0 L203.9 477.0 L201.6 480.0 L199.0 483.0 L196.2 486.0 L193.2 489.0 L190.2 492.0 L187.3 495.0 L184.5 498.0 L181.9 501.0 L179.7 504.0 L177.8 507.0 L176.4 510.0 L175.5 513.0 L175.0 516.0 L175.1 519.0 L175.8 522.0 L176.9 525.0 L178.5 528.0 L180.5 531.0 L182.9 534.0 L185.5 537.0 L188.4 540.0 L191.4 543.0' fill='none' stroke='%23d90012' stroke-width='10' stroke-linecap='round'/%3E%3Cpath d='M192.0 330.0 L189.0 333.0 L186.1 336.0 L183.4 339.0 L181.0 342.0 L178.9 345.0 L177.2 348.0 L175.9 351.0 L175.2 354.0 L175.0 357.0 L175.3 360.0 L176.2 363.0 L177.5 366.0 L179.3 369.0 L181.4 372.0 L183.9 375.0 L186.7 378.0 L189.6 381.0 L192.6 384.0 L195.6 387.0 L198.4 390.0 L201.1 393.0 L203.5 396.0 L205.5 399.0 L207.1 402.0 L208.2 405.0 L208.9 408.0 L209.0 411.0 L208.6 414.0 L207.6 417.0 L206.2 420.0 L204.3 423.0 L202.1 426.0 L199.5 429.0 L196.8 432.0 L193.8 435.0 L190.8 438.0 L187.9 441.0 L185.0 444.0 L182.4 447.0 L180.1 450.0 L178.2 453.0 L176.6 456.0 L175.6 459.0 L175.1 462.0 L175.1 465.0 L175.6 468.0 L176.6 471.0 L178.1 474.0 L180.1 477.0 L182.4 480.0 L185.0 483.0 L187.8 486.0 L190.8 489.0 L193.8 492.0 L196.7 495.0 L199.5 498.0 L202.1 501.0 L204.3 504.0 L206.2 507.0 L207.6 510.0 L208.5 513.0 L209.0 516.0 L208.9 519.0 L208.2 522.0 L207.1 525.0 L205.5 528.0 L203.5 531.0 L201.1 534.0 L198.5 537.0 L195.6 540.0 L192.6 543.0' fill='none' stroke='%23d90012' stroke-width='10' stroke-linecap='round'/%3E%3Ccircle cx='192' cy='330.0' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='356.7' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='383.4' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='410.1' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='436.8' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='463.5' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='490.2' r='5' fill='%23d90012'/%3E%3Cg transform='translate(192 170) rotate(0)'%3E%3Cpath d='M0 18 L0 -6' stroke='%23d90012' stroke-width='6' stroke-linecap='round'/%3E%3Cpath d='M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(192 555) rotate(180)'%3E%3Cpath d='M0 18 L0 -6' stroke='%23d90012' stroke-width='6' stroke-linecap='round'/%3E%3Cpath d='M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z' fill='%23d90012'/%3E%3C/g%3E%3Cpath d='M192 560 L165 590 L192 600 L219 590Z' fill='none' stroke='%23d90012' stroke-width='6' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-size: 104px 163px;
  -webkit-mask-image: radial-gradient(ellipse 80% 90% at 50% 0%, #000 20%, transparent 75%);
  mask-image: radial-gradient(ellipse 80% 90% at 50% 0%, #000 20%, transparent 75%);
}

.bg-cross {
  position: absolute;
  top: 150px;
  right: 1vw;
  z-index: 0;
  width: clamp(130px, 16vw, 250px);
  aspect-ratio: 453 / 752;
  height: auto;
  color: rgba(217, 0, 18, 0.09);
  pointer-events: none;
  user-select: none;
}

/* Header */
.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 28px;
  flex-wrap: wrap;
  margin-bottom: 22px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 18px;
}

.brand-mark {
  width: 76px;
  height: 76px;
  flex: none;
  display: grid;
  place-items: center;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 50%;
  box-shadow: 0 10px 30px rgba(143, 0, 16, .12);
}

.brand-mark img {
  width: 54px;
  height: auto;
  object-fit: contain;
}

.eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .16em;
  text-transform: uppercase;
  color: var(--red);
  margin-bottom: 4px;
}

.eyebrow-cross {
  width: 14px;
  height: 22px;
  flex: none;
}

.top-header h1 {
  margin: 0;
  font-family: Fraunces, Georgia, serif;
  font-size: clamp(26px, 3.2vw, 38px);
  font-weight: 600;
  letter-spacing: -.02em;
  line-height: 1.1;
}

.top-header p {
  margin: 6px 0 0;
  color: var(--muted);
  font-size: 14px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.nav-btn {
  height: 42px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
  background: rgba(255, 255, 255, .85);
  backdrop-filter: blur(6px);
  color: var(--ink);
  border: 1px solid var(--line);
  border-radius: 999px;
  font-weight: 600; font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  transition: .2s ease;
}

.nav-btn svg,
.search svg,
.date-text svg,
.stat-icon svg {
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.nav-btn svg { width: 17px; height: 17px; }

.nav-btn:hover {
  border-color: var(--red);
  color: var(--red);
  transform: translateY(-1px);
}

.nav-btn.primary {
  background: var(--ink);
  border-color: var(--ink);
  color: #fff;
}

.nav-btn.primary:hover {
  background: var(--red);
  border-color: var(--red);
  color: #fff;
}

.spin { animation: spin 1s linear infinite; }

.tricolor {
  height: 4px;
  width: 100%;
  border-radius: 4px;
  background: var(--tricolor);
  margin-bottom: 30px;
}

/* Stats */
.stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 26px;
}

.stat-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 22px;
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 18px;
  box-shadow: 0 6px 22px rgba(60, 40, 20, .05);
  overflow: hidden;
  transition: .25s ease;
}

.stat-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: var(--accent, var(--blue));
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 16px 36px rgba(60, 40, 20, .1);
}

.stat-icon {
  width: 50px;
  height: 50px;
  flex: none;
  display: grid;
  place-items: center;
  border-radius: 14px;
  color: var(--accent, var(--blue));
  background: color-mix(in srgb, var(--accent, var(--blue)) 10%, #fff);
}

.stat-icon svg { width: 24px; height: 24px; }

.stat-card h2 {
  margin: 0;
  font-family: Fraunces, Georgia, serif;
  font-size: 34px;
  font-weight: 600;
  line-height: 1;
}

.stat-card p {
  margin: 6px 0 0;
  color: var(--muted);
  font-size: 13px;
}

.urgent-box { --accent: var(--red); }
.waiting-box { --accent: #d98e00; }
.done-box { --accent: var(--green); }

/* Search */
.search {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 18px;
  margin-bottom: 14px;
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 14px;
  box-shadow: 0 6px 22px rgba(60, 40, 20, .04);
  transition: .2s ease;
}

.search:focus-within {
  border-color: var(--red);
  box-shadow: 0 0 0 4px rgba(217, 0, 18, .08);
}

.search svg { width: 20px; height: 20px; color: var(--muted); flex: none; }

.search input {
  flex: 1;
  height: 48px;
  border: none;
  outline: none;
  background: transparent;
  font-weight: 500; font-size: 15px;
  font-family: inherit;
  color: var(--ink);
}

.search input::placeholder { color: #b3a99c; }

.clear {
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: var(--paper-2);
  color: var(--muted);
  cursor: pointer;
}

.clear:hover { background: var(--red); color: #fff; }

/* Filters */
.filters {
  display: flex;
  flex-wrap: wrap;
  gap: 18px 36px;
  padding: 20px 22px;
  margin-bottom: 26px;
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 18px;
  box-shadow: 0 6px 22px rgba(60, 40, 20, .04);
}

.filter-group p {
  margin: 0 0 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .14em;
  text-transform: uppercase;
  color: var(--muted);
}

.seg {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
  padding: 4px;
  background: var(--paper-2);
  border-radius: 12px;
}

.seg button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 14px;
  border: none;
  border-radius: 9px;
  background: transparent;
  color: #5d5348;
  font-weight: 600; font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  transition: .18s ease;
}

.seg button:hover { color: var(--ink); background: rgba(255, 255, 255, .6); }

.seg button.active {
  background: #fff;
  color: var(--ink);
  box-shadow: 0 2px 8px rgba(60, 40, 20, .12);
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  background: currentColor;
}

.dot.green { background: var(--green); }
.dot.orange { background: var(--orange); }
.dot.red { background: var(--red); }

.count {
  margin: 0 0 16px;
  color: var(--muted);
  font-size: 14px;
}

.count strong {
  color: var(--ink);
  font-family: Fraunces, Georgia, serif;
  font-size: 20px;
  margin-right: 2px;
}

/* Cards */
.card {
  position: relative;
  padding: 26px 28px;
  margin-bottom: 16px;
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 20px;
  box-shadow: 0 6px 22px rgba(60, 40, 20, .045);
  overflow: hidden;
  transition: .25s ease;
}

.card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  background: var(--green);
}

.card.important::before { background: var(--orange); }
.card.urgent::before { background: var(--red); }

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 18px 40px rgba(60, 40, 20, .1);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
}

.who {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.avatar {
  width: 48px;
  height: 48px;
  flex: none;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: var(--ink);
  color: #fff;
  font-family: Fraunces, Georgia, serif;
  font-size: 17px;
  font-weight: 600;
  box-shadow: 0 0 0 3px var(--paper), 0 0 0 4px var(--line);
}

.card-header h2 {
  margin: 0;
  font-family: Fraunces, Georgia, serif;
  font-size: 21px;
  font-weight: 600;
  letter-spacing: -.01em;
}

.card-header p {
  margin: 3px 0 0;
  color: var(--muted);
  font-size: 13px;
  word-break: break-all;
}

.badges {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 7px;
}

.urgency,
.status,
.publication {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.urgency { background: #eaf6ee; color: var(--green); }
.urgency.important { background: #fff3d6; color: #9a6500; }
.urgency.urgent { background: #fde8ea; color: var(--red-deep); }

.status.done { background: #eaf6ee; color: var(--green); }
.status.waiting { background: #fff3d6; color: #9a6500; }

.publication.online { background: #e8eefb; color: var(--blue); }
.publication.draft { background: var(--paper-2); color: var(--muted); }

.date-text {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 16px;
  color: #a2968a;
  font-size: 13px;
}

.date-text svg { width: 15px; height: 15px; }

.message {
  margin: 16px 0 4px;
  padding: 16px 18px;
  background: var(--paper);
  border-left: 3px solid var(--line);
  border-radius: 0 12px 12px 0;
  font-size: 15px;
  line-height: 1.75;
  color: #3c342c;
  white-space: pre-line;
}

.photo {
  display: block;
  width: 340px;
  max-width: 100%;
  margin-top: 16px;
  border-radius: 14px;
  border: 1px solid var(--line);
}

/* Actions */
.actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 20px;
  padding-top: 18px;
  border-top: 1px dashed var(--line);
}

.actions button {
  padding: 10px 16px;
  border: 1px solid var(--line);
  border-radius: 10px;
  background: #fff;
  color: var(--ink);
  font-weight: 600; font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  transition: .18s ease;
}

.actions button:hover { transform: translateY(-1px); border-color: #cfc3af; background: var(--paper); }

.actions .publish { background: var(--red); border-color: var(--red); color: #fff; }
.actions .publish:hover { background: var(--red-deep); border-color: var(--red-deep); }

.actions .treat { background: var(--green); border-color: var(--green); color: #fff; }
.actions .treat:hover { background: #17622e; border-color: #17622e; }

.actions .unpublish { background: #fff6e5; border-color: #f0cf8c; color: #9a5a00; }
.actions .unpublish:hover { background: #ffedc8; }

.actions .delete { color: var(--red); border-color: #efc3c7; }
.actions .delete:hover { background: #fff1f2; border-color: var(--red); }

.closed {
  margin-right: auto;
  padding: 9px 14px;
  border-radius: 10px;
  background: #eaf6ee;
  border: 1px solid #c9e6d2;
  color: var(--green);
  font-size: 13px;
  font-weight: 700;
}

/* Empty */
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 60px 30px;
  background: var(--card);
  border: 1px dashed #d8cdb9;
  border-radius: 20px;
  color: var(--muted);
  text-align: center;
}

.empty-cross { width: 44px; height: 70px; color: var(--red); opacity: .6; }

.loader {
  width: 30px;
  height: 30px;
  border: 3px solid var(--paper-2);
  border-top-color: var(--red);
  border-radius: 50%;
  animation: spin .8s linear infinite;
}

/* Modal */
.modal {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background: rgba(28, 21, 17, .5);
  backdrop-filter: blur(6px);
}

.modal-box {
  width: 540px;
  max-width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  padding: 32px;
  background: #fff;
  border-radius: 22px;
  border-top: 4px solid transparent;
  border-image: var(--tricolor) 1;
  box-shadow: 0 30px 80px rgba(0, 0, 0, .3);
  animation: popup .22s ease;
}

.modal-header { margin-bottom: 8px; }

.modal-box h2 {
  margin: 0;
  font-family: Fraunces, Georgia, serif;
  font-size: 26px;
  font-weight: 600;
}

.modal-box label {
  display: block;
  margin: 18px 0 8px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .1em;
  text-transform: uppercase;
  color: var(--muted);
}

.modal textarea,
.modal select {
  width: 100%;
  padding: 14px;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: var(--paper);
  font-weight: 500; font-size: 15px;
  font-family: inherit;
  color: var(--ink);
  outline: none;
  transition: .2s ease;
}

.modal textarea { height: 170px; resize: vertical; line-height: 1.6; }

.modal textarea:focus,
.modal select:focus {
  background: #fff;
  border-color: var(--red);
  box-shadow: 0 0 0 4px rgba(217, 0, 18, .08);
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 26px;
}

.modal-actions button {
  padding: 12px 22px;
  border: none;
  border-radius: 11px;
  font-weight: 700; font-size: 14px;
  font-family: inherit;
  cursor: pointer;
  transition: .18s ease;
}

.modal-actions .save { background: var(--red); color: #fff; }
.modal-actions .save:hover { background: var(--red-deep); }
.modal-actions .cancel { background: var(--paper-2); color: var(--ink); }
.modal-actions .cancel:hover { background: #e9dfcc; }

/* Animations */
@keyframes spin { to { transform: rotate(360deg); } }

@keyframes popup {
  from { transform: translateY(12px) scale(.98); opacity: 0; }
  to { transform: none; opacity: 1; }
}

/* Tablet */
@media (max-width: 1000px) {
  .shell { padding: 28px 22px 60px; }
  .stats { grid-template-columns: repeat(2, 1fr); }
}

/* Mobile */
@media (max-width: 700px) {
  .shell { padding: 20px 14px 50px; }
  .bg-cross { top: 230px; right: -30px; width: 140px; opacity: .7; }
  .lattice { height: 480px; background-size: 80px 125px; }

  .top-header { flex-direction: column; align-items: flex-start; gap: 18px; }
  .brand-mark { width: 62px; height: 62px; }
  .brand-mark img { width: 44px; }

  .header-actions { width: 100%; display: grid; grid-template-columns: 1fr 1fr; }
  .nav-btn { justify-content: center; padding: 0 10px; }
  .nav-btn.primary { grid-column: 1 / -1; }

  .stats { gap: 10px; }
  .stat-card { flex-direction: column; align-items: flex-start; gap: 12px; padding: 16px; }
  .stat-card h2 { font-size: 28px; }

  .filters { flex-direction: column; gap: 16px; padding: 16px; }
  .seg { display: flex; width: 100%; }
  .seg button { flex: 1; justify-content: center; padding: 8px 6px; }

  .card { padding: 20px 18px; }
  .card-header { flex-direction: column; }
  .badges { justify-content: flex-start; }

  .actions { flex-direction: column; align-items: stretch; }
  .actions button { width: 100%; }
  .closed { margin-right: 0; text-align: center; }

  .photo { width: 100%; }

  .modal { padding: 10px; align-items: flex-end; }
  .modal-box { padding: 24px 18px; border-radius: 20px 20px 0 0; }
  .modal-actions { flex-direction: column-reverse; }
  .modal-actions button { width: 100%; }
}

/* --- Événements --- */
.stats { grid-template-columns: repeat(3, 1fr); }

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.toolbar .seg {
  padding: 5px;
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: 14px;
  box-shadow: 0 6px 22px rgba(60, 40, 20, .04);
}

.toolbar .seg button { padding: 10px 16px; }
.toolbar .seg button.active { background: var(--ink); color: #fff; box-shadow: none; }
.toolbar .count { margin: 0; }

.pill {
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  display: inline-grid;
  place-items: center;
  border-radius: 20px;
  background: var(--red);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

.event-card { display: flex; padding: 0; }
.event-card::before { background: var(--orange); z-index: 2; }
.event-card.published::before { background: var(--green); }

.event-image {
  width: 250px;
  min-width: 250px;
  background: var(--paper-2);
}

.event-image img {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 240px;
  object-fit: cover;
}

.event-content { flex: 1; min-width: 0; padding: 24px 28px; }

.event-content h3 {
  margin: 12px 0 12px;
  font-family: Fraunces, Georgia, serif;
  font-size: 23px;
  font-weight: 600;
  letter-spacing: -.01em;
  line-height: 1.25;
}

.meta { list-style: none; margin: 0; padding: 0; display: grid; gap: 6px; }

.meta li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: #5d5348;
  font-size: 14px;
}

.meta svg {
  width: 16px;
  height: 16px;
  margin-top: 2px;
  flex: none;
  fill: none;
  stroke: var(--red);
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.cap::first-letter { text-transform: uppercase; }

.event-description {
  margin: 14px 0 0;
  color: var(--muted);
  font-size: 14px;
  line-height: 1.65;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.event-content .actions { justify-content: flex-start; }

/* Modal large + formulaire */
.modal-box.wide { width: 760px; }

.modal-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 10px;
}

.modal-head p { margin: 6px 0 0; color: var(--muted); font-size: 14px; }

.close-btn {
  width: 36px;
  height: 36px;
  flex: none;
  border: none;
  border-radius: 50%;
  background: var(--paper-2);
  color: var(--ink);
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}

.close-btn:hover { background: var(--red); color: #fff; }

.form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 4px 18px; }
.form-group { display: flex; flex-direction: column; }
.form-group.full { grid-column: 1 / -1; }

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 13px 14px;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: var(--paper);
  font-family: inherit;
  font-size: 15px;
  color: var(--ink);
  outline: none;
  transition: .2s ease;
}

.form-group textarea { min-height: 130px; resize: vertical; line-height: 1.6; }

.form-group input:focus,
.form-group textarea:focus {
  background: #fff;
  border-color: var(--red);
  box-shadow: 0 0 0 4px rgba(217, 0, 18, .08);
}

.image-preview { grid-column: 1 / -1; max-width: 420px; margin-top: 10px; }

.image-preview img {
  display: block;
  width: 100%;
  max-height: 240px;
  object-fit: cover;
  border-radius: 14px;
  border: 1px solid var(--line);
}

.modal-actions .save:disabled { opacity: .6; cursor: not-allowed; }

@media (max-width: 1000px) {
  .stats { grid-template-columns: 1fr; }
  .event-image { width: 200px; min-width: 200px; }
}

@media (max-width: 700px) {
  .stat-card { flex-direction: row; align-items: center; }
  .toolbar { flex-direction: column; align-items: stretch; }
  .toolbar .seg { display: flex; }
  .toolbar .seg button { flex: 1; justify-content: center; padding: 10px 6px; }

  .event-card { flex-direction: column; }
  .event-image { width: 100%; min-width: 0; height: 190px; }
  .event-image img { min-height: 190px; }
  .event-content { padding: 20px 18px; }
  .event-content h3 { font-size: 20px; }

  .form-grid { grid-template-columns: 1fr; }
  .form-group.full { grid-column: auto; }
}
</style>